var map = {
	"./de/countries.json": 9944,
	"./en/countries.json": 4396,
	"./es/countries.json": 4191,
	"./fr/countries.json": 3316,
	"./hu/countries.json": 6244,
	"./it/countries.json": 8182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3846;